import hintDlg from './src/main.js'
export default hintDlg



// WEBPACK FOOTER //
// ./src/components/hintDlg/index.js